import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Icon } from '../../../../../Icon/Icon.js';
import { useMarkerContext } from '../../../contexts/MarkerContext.js';
import { useMarkerIcon } from '../../../hooks/useMarker.js';

var MarkerIcon = function MarkerIcon(_ref) {
  var icon = _ref.icon;
  var _useMarkerContext = useMarkerContext(),
    size = _useMarkerContext.size;
  var iconProps = useMarkerIcon(useMarkerContext());
  if (size === 'xs') return null;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    size: "12"
  }, iconProps, {
    id: icon
  }));
};

export { MarkerIcon };
//# sourceMappingURL=MarkerIcon.js.map
